// AUTOGENERATED - MANUALLY CHANGES WILL BE REVERTED BY THE GENERATOR
// https://sepolia.basescan.org/address/0x95F99D1695c866FEb16657cCA8E91437a50D2a5e
export const TRANSPARENT_PROXY_FACTORY = '0x95F99D1695c866FEb16657cCA8E91437a50D2a5e';

// https://sepolia.basescan.org/address/0x6CBc6928Ad317F60E8880C43479850F2190F2a0B
export const PROXY_ADMIN = '0x6CBc6928Ad317F60E8880C43479850F2190F2a0B';

// https://sepolia.basescan.org/address/0xD9145b5F45Ad4519c7ACcD6E0A4A82e83bB8A6Dc
export const FAUCET = '0xD9145b5F45Ad4519c7ACcD6E0A4A82e83bB8A6Dc';

export const CHAIN_ID = 84532;
